import { RequestMethodTypes } from "../helpers/constants";
import { fetchWrapper } from "../helpers";

/**
 * PUT /v1/candidate/{oktaSubId}/documentrequests/types/status
 * @param {string} oktaSubId Okta Sub ID
 * @param {string} status 'requested' or 'uploaded'
 * @param {Array<{requestid: number, typeid: number}>} items Array of request/type pairs
 * @returns {Promise<Object>}
 */
export const updateDocumentRequestTypeStatus = async (oktaSubId, status, items) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.PUT,
    url: `${oktaSubId}/documentrequests/types/status`,
    data: { status, items },
  });
  return response?.data;
};

// Document Request Types Handlers
/**
 * GET /v1/candidate/documentrequesttypes
 * @returns {Promise<Object>} List of document request types
 */
export const getDocumentRequestTypes = async () => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url: `documentrequesttypes`,
  });
  return response?.data;
};

/**
 * POST /v1/candidate/documentrequesttypes
 * @param {Object} data Document request type data
 * @returns {Promise<Object>}
 */
export const insertDocumentRequestType = async (data) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.POST,
    url: `documentrequesttypes`,
    data,
  });
  return response?.data;
};

/**
 * PUT /v1/candidate/documentrequesttypes/:typeid
 * @param {string|number} typeid Type ID
 * @param {Object} data Updated data
 * @returns {Promise<Object>}
 */
export const updateDocumentRequestType = async (typeid, data) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.PUT,
    url: `documentrequesttypes/${typeid}`,
    data,
  });
  return response?.data;
};

/**
 * DELETE /v1/candidate/documentrequesttypes/:typeid
 * @param {string|number} typeid Type ID
 * @returns {Promise<Object>}
 */
export const deleteDocumentRequestType = async (typeid) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.DELETE,
    url: `documentrequesttypes/${typeid}`,
  });
  return response?.data;
};

// Document Requests Handlers
/**
 * GET /v1/candidate/:oktasubid/documentrequests
 * @param {string} oktaSubId Okta Sub ID
 * @param {string} status requested, completed (optional), contractid* (required)
 * limit, offset
 * @returns {Promise<Object>}
 */
export const getDocumentRequests = async (
  oktaSubId,
  status = "",
  contractid,
  limit,
  offset
) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.GET,
    url: `${oktaSubId}/documentrequests?status=${status}&contractid=${contractid}&limit=${limit}&offset=${offset}`,
  });
  return response?.data;
};

/**
 * POST /v1/candidate/:oktasubid/documentrequests
 * @param {string} oktaSubId Okta Sub ID
 * @param {Object} data Document request data
 *  data = {
 *   contractId,
     note = "",
     status = "requested",
     typeIds = [],
   }
 * @returns {Promise<Object>}
 */
export const insertDocumentRequest = async (oktaSubId, data) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.POST,
    url: `${oktaSubId}/documentrequests`,
    data,
  });
  return response?.data;
};

/**
 * PUT /v1/candidate/:oktasubid/documentrequests/:requestid
 * @param {string} oktaSubId Okta Sub ID
 * @param {string|number} requestId Request ID
 * @param {Object} data Updated data
 *  data = {
 *   contractId,
     note = "",
     status = "requested",
     typeIds = [],
   }
 * @returns {Promise<Object>}
 */
export const updateDocumentRequest = async (oktaSubId, requestId, data) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.PUT,
    url: `${oktaSubId}/documentrequests/${requestId}`,
    data,
  });
  return response?.data;
};

/**
 * DELETE /v1/candidate/:oktasubid/documentrequests/:requestid
 * @param {string} oktaSubId Okta Sub ID
 * @param {string|number} requestId Request ID
 * @returns {Promise<Object>}
 */
export const deleteDocumentRequest = async (oktaSubId, requestId) => {
  const response = await fetchWrapper({
    method: RequestMethodTypes.DELETE,
    url: `${oktaSubId}/documentrequests/${requestId}`,
  });
  return response?.data;
};
